export enum VideoServiceType {
  Jicoo = 1,
  GoogleMeet = 10,
  MicrosoftTeams = 20,
  Zoom = 30,
}

export function findVideoServiceType(
  url?: string | null,
  description?: string | null,
): { url: string; videoServiceType: VideoServiceType }[] {
  const videoServices = [];
  if (url) {
    const videoServiceType = findVideoServiceTypeFromUrl(url);
    if (videoServiceType) {
      videoServices.push({
        url,
        videoServiceType,
      });
    }
  }
  if (description) {
    const matches = findVideoServiceTypeFromText(description);
    if (matches) {
      videoServices.push({
        url: matches.url,
        videoServiceType: matches.videoServiceType,
      });
    }
  }
  return videoServices;
}

export function findVideoServiceTypeFromUrl(
  urlString: string,
): VideoServiceType | null {
  const url = new URL(urlString);
  if (url.host === 'meet.google.com') {
    return VideoServiceType.GoogleMeet;
  } else if (url.host.match(/((.+\.zoom.us)|^zoom.us)/)) {
    return VideoServiceType.Zoom;
  } else if (url.host.match(/((.+\.microsoft.com)|^microsoft.com)/)) {
    return VideoServiceType.MicrosoftTeams;
  } else {
    return null;
  }
}

interface VideoServiceMatch {
  videoServiceType: VideoServiceType;
  url: string;
}
export function findVideoServiceTypeFromText(
  text: string,
): VideoServiceMatch | null {
  const matches = text.match(/https:\/\/(.+\.)?zoom.us\/(.+)(\s|\n)/);
  if (matches) {
    return {
      videoServiceType: VideoServiceType.Zoom,
      url: matches[0],
    };
  }
  return null;
}
